import React, { Component } from 'react'
import Headroom from 'react-headroom'
import { getNav2, pollForAccount, appCheck } from 'sfc-utils'
import '../../styles/nav.less'
require('sfc-utils/css/nav2.less')

// Get data from config
let projectConfig = require('../../../project-config.json')
let project = projectConfig.PROJECT

// story settings from sheet
let storySettings = require("../../data/story_settings.sheet.json");
storySettings = storySettings[0];

class NavTop extends Component {
  constructor(props) {
    super(props)

    this.navObj = false
    if (storySettings.NavTitle){
      let navURL = "#___gatsby"
      if (storySettings.NavLink){
        navURL = storySettings.NavLink
      }
      this.navObj = {
        url: navURL,
        text: storySettings.NavTitle,
        target: "_self"
      }
    }

    // CT starts empty, gets set after
    let navHTML = "";
    if (['Texcom','Midcom','CT'].indexOf(storySettings.Market_Key) === -1){
      navHTML = getNav2(false, this.props.url_add, false, this.navObj, false)
    }
    this.state = {
      navHTML: navHTML,
      hide: false
    }
  }

  componentDidMount(){
    let hide = false
    if (appCheck()){
      hide = true
    }
    this.setState({
      navHTML: getNav2(false, this.props.url_add, false, this.navObj, false),
      hide: hide
    });
    pollForAccount();
  }

  render() {
    // Only include subfolder if it exists
    let subfolder = ''
    if (typeof storySettings.Year !== 'undefined') {
      subfolder = storySettings.Year + '%2F'
    }

    // Enable the social popup
    this.handleFacebookClick = e => {
      const el = e.target.closest("#topper-nav-facebook-icon");
      if (el && e.currentTarget.contains(el)) {
        const link = el.getAttribute("href");
        e.preventDefault()
        window.open(
          link,
          'facebook-share-dialog',
          'width=626,height=436'
        )
        return false
      }
    }

    // Set the navClass
    let tempNavClass = ""
    if (!this.state.hide){
      tempNavClass += " not-app"
    }

    return (
      <Headroom
        style={{
          zIndex: '2147483647',
        }}
      >
        {this.state.navHTML &&
          <div className={tempNavClass} onClick={this.handleFacebookClick} dangerouslySetInnerHTML={{__html: this.state.navHTML}} />
        }
      </Headroom>
    )
  }
}

NavTop.defaultProps = {
  url_add: '',
}

export default NavTop
